import { request } from '../utils/request'
import { stringify } from '../utils/index'

export default {
  getexperts: option => request('v1/expert/getexperts', option), // 产品列表
  getexpert: option => request('v1/expert/getexpert' + stringify(option), option), // 产品列表
  deleteexpert: (option) => request('v1/expert/deleteexpert' + stringify(option), option), // 删除产品
  addexpert: (option) => request('v1/expert/addexpert', option), // 新增产品
  updateexpert: (option) => request('v1/expert/updateexpert', option) // 修改产品
}
